import React from 'react';
import { Transition } from 'react-transition-group';
import { Property } from 'csstype';
import {
    TransitionStatus,
    TransitionProps,
} from 'react-transition-group/Transition';

const defaultDuration = 0.3;

type TransitionStyles = { [key in TransitionStatus]: React.CSSProperties };
type RenderProps = {
    style: React.CSSProperties;
};

export type FadeProps = Partial<TransitionProps> & {
    duration?: number;
    delay?: number;
    transitionTimingFunction?: Property.TransitionTimingFunction;
    transitionStyles?: TransitionStyles;
    children(props: RenderProps): JSX.Element;
};

const defaultTransitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 1 },
    exited: { opacity: 0 },
} as TransitionStyles;

const Fade: React.FC<FadeProps> = ({
    children,
    duration = defaultDuration,
    delay = 0,
    transitionTimingFunction = 'ease',
    transitionStyles = defaultTransitionStyles,
    ...props
}) => (
    <Transition timeout={duration} appear={true} {...props}>
        {(state) =>
            children({
                style: {
                    transition: `all ${duration}s ${transitionTimingFunction} ${delay}s`,
                    opacity: 0,
                    ...transitionStyles[state],
                },
            })
        }
    </Transition>
);

export default Fade;
